import type { ReactNode } from "react";

import React, { useEffect } from "react";
import { Container, Row } from "react-bootstrap";
import { useLocation } from "react-router-dom";

import Heading from "../heading";
import Menu from "../menu";

interface IWrapperProps {
  children: ReactNode;
  mainBlockClassName?: string;
  embed?: boolean;
  hideHeading?: boolean;
}

export default function Wrapper({
  children,
  mainBlockClassName = "width-wrapper",
  embed = false,
  hideHeading = false,
}: IWrapperProps) {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  useEffect(() => {
    if (!embed) return;

    const root = document.getElementById("root");

    document.documentElement.classList.add("page--embed");
    document.body.classList.add("page--embed");
    if (root) root.classList.add("page--embed");

    return () => {
      document.documentElement.classList.remove("page--embed");
      document.body.classList.remove("page--embed");
      if (root) root.classList.remove("page--embed");
    };
  }, [embed]);

  return (
    <Container fluid className={`gx-lg-0${embed ? " h-100" : ""}`}>
      <Row
        className={`m-md-0 gx-md-0 wrapper d-lg-flex${embed ? " wrapper--embed h-100 d-flex flex-column flex-lg-row flex-lg-nowrap" : ""}`}
      >
        <Menu />
        <div
          className={`col-12 col-lg-9 col-xl-10 bg-white${embed ? " wrapper__embed-content px-0" : " mt-5 mt-lg-0"}`}
        >
          <div
            className={`col-12 text-dark${embed ? " wrapper__embed-inner" : ` col-lg-10 col-xl-10 offset-lg-1${!mainBlockClassName.includes("mt") ? " mt-5" : ""} ${mainBlockClassName}`}`}
          >
            {!embed && !hideHeading && <Heading />}
            {children}
          </div>
        </div>
      </Row>
    </Container>
  );
}
